var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatchesGuest(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "293px",
    height: "82px",
    viewBox: "0 0 293 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "matches-guest") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M180.551319,17 C181.462644,17 182.377316,17.3531271 183.069514,18.058421 L183.069514,18.058421 L183.899729,18.9069442 L184.729958,18.0628869 C186.11434,16.6522691 188.377374,16.6523006 189.76174,18.0628869 C191.146122,19.4734747 191.146122,21.7389694 189.76174,23.1495586 C187.87778,25.0692003 185.99467,26.9909856 184.110725,28.9105843 C184.055272,28.9676616 183.978134,29 183.897439,29 C183.816744,29 183.739607,28.9676616 183.684154,28.9105843 L183.684154,28.9105843 L178.037718,23.1450855 C177.330777,22.4233777 176.984839,21.4787929 177.000537,20.5393676 C176.995661,20.2929871 177.024764,20.0458772 177.087876,19.8047911 C177.230297,19.1659481 177.546901,18.5585208 178.037718,18.058421 C178.729901,17.3531257 179.639994,17 180.551319,17 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0866699,35.8653415 L70.1108586,35.7670409 C70.2979951,34.9053795 70.72215,34.0852038 71.3836151,33.411228 C72.3065262,32.4708343 73.5199826,32 74.735083,32 C75.9501834,32 77.1697459,32.4708362 78.0926766,33.411228 L78.0926766,33.411228 L79.1996298,34.5425922 L80.3066025,33.4171826 C82.1524443,31.5363588 85.1698227,31.5364008 87.0156449,33.4171826 C88.8614867,35.2979663 88.8614867,38.3186259 87.0156449,40.1994115 C84.5036977,42.7589337 81.9928851,45.3213141 79.4809574,47.8807791 C79.4070202,47.9568822 79.3041702,48 79.1965768,48 C79.0889834,48 78.9861333,47.9568822 78.9121962,47.8807791 L78.9121962,47.8807791 L71.3836151,40.1934474 C70.4335652,39.2235521 69.9725028,37.9517638 70.0012956,36.6894093 C69.9971288,36.4130314 70.0259301,36.1367521 70.0866699,35.8653415 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.918847,43 C271.437723,43 272.962176,43.5885452 274.115839,44.764035 L274.115839,44.764035 L275.499531,46.1782403 L276.883247,44.7714782 C279.190549,42.4204486 282.962272,42.420501 285.26955,44.7714782 C287.576852,47.1224578 287.576852,50.8982823 285.26955,53.2492643 C282.129616,56.4486671 278.9911,59.6516426 275.85119,62.8509739 C275.758769,62.9461027 275.630206,63 275.495714,63 C275.361223,63 275.23266,62.9461027 275.140239,62.8509739 L275.140239,62.8509739 L265.729512,53.2418092 C264.549364,52.037009 263.972842,50.4595394 264.00101,48.8913162 C263.993363,48.4820797 264.042153,48.0720362 264.147145,47.6719712 C264.384464,46.6086609 264.91199,45.5970191 265.729512,44.764035 C266.883151,43.5885428 268.399972,43 269.918847,43 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.070577,35.347576 C281.19144,34.8058753 281.455384,34.2991455 281.864769,33.8820175 C282.441589,33.2942714 283.199999,33 283.959437,33 C284.718874,33 285.481101,33.2942726 286.057933,33.8820175 L286.057933,33.8820175 L286.749778,34.5891201 L287.441636,33.8857391 C288.595288,32.7102243 290.481149,32.7102505 291.634788,33.8857391 C292.788439,35.0612289 292.788439,36.9491412 291.634788,38.1246322 C290.064821,39.7243336 288.495563,41.3258213 286.925608,42.925487 C286.879397,42.9730514 286.815116,43 286.74787,43 C286.680624,43 286.616343,42.9730514 286.570132,42.925487 L286.570132,42.925487 L281.864769,38.1209046 C281.311651,37.5562322 281.023725,36.8278342 281.00143,36.09299 L281.001455,35.8253672 C281.007197,35.6648085 281.030235,35.5046878 281.070577,35.347576 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0013742,30.9092357 C34.0232173,30.1744093 34.3090776,29.4462435 34.8593907,28.8820175 C35.4326274,28.2942714 36.1863271,28 36.9410478,28 C37.6957686,28 38.4532608,28.2942726 39.0265097,28.8820175 L39.0265097,28.8820175 L39.7140582,29.5891201 L40.4016189,28.8857391 C41.5481045,27.7102243 43.4222526,27.7102505 44.568726,28.8857391 C45.7152116,30.0612289 45.7152116,31.9491412 44.568726,33.1246322 C43.0085103,34.7243336 41.4489994,36.3258213 39.8887959,37.925487 C39.8428722,37.9730514 39.7789901,38 39.7121619,38 C39.6453337,38 39.5814517,37.9730514 39.535528,37.925487 L39.535528,37.925487 L34.8593907,33.1209046 C34.5569071,32.8101725 34.3342294,32.4498617 34.19143,32.0661805 C34.0746786,31.7952765 34.0114567,31.5088816 34.0014347,31.221153 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.35262,12 C227.239421,12 229.133152,12.7356815 230.566274,14.2050438 L230.566274,14.2050438 L232.285146,15.9728004 L234.004047,14.2143477 C236.870261,11.2755607 241.555631,11.2756262 244.421815,14.2143477 C247.288029,17.1530723 247.288029,21.8728529 244.421815,24.8115804 L244.421815,24.8115804 L232.72199,36.8137174 C232.60718,36.9326284 232.447475,37 232.280405,37 C232.113334,37 231.953629,36.9326284 231.83882,36.8137174 L231.83882,36.8137174 L220.148477,24.8022616 C219.39506,24.0282993 218.839687,23.1313038 218.482537,22.1760728 C218.138961,21.3817753 217.978839,20.5327175 218.002295,19.6875527 C217.954347,17.7119959 218.669286,15.7216315 220.148477,14.2050438 C221.581568,12.7356785 223.465818,12 225.35262,12 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88209562,62 C7.39153711,62 8.90652159,62.5885452 10.0530193,63.764035 L10.0530193,63.764035 L11.4281164,65.1782403 L12.8032379,63.7714782 C15.096209,61.4204486 18.8445052,61.420501 21.137452,63.7714782 C23.4304232,66.1224578 23.4304232,69.8982823 21.137452,72.2492643 C18.0170206,75.4486671 14.8979988,78.6516426 11.7775917,81.8509739 C11.6857443,81.9461027 11.5579803,82 11.4243239,82 C11.2906675,82 11.1629034,81.9461027 11.071056,81.8509739 L11.071056,81.8509739 L1.71878136,72.2418092 C1.11291423,71.6194205 0.667133941,70.897579 0.3815863,70.1289358 C0.111379467,69.5012084 -0.0151478366,68.8308726 0.00148724183,68.1632729 C-0.0398459237,66.5788673 0.531984794,64.9808359 1.71878136,63.764035 C2.86525478,62.5885428 4.37265413,62 5.88209562,62 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.001374,2.90923567 C100.023217,2.17440934 100.309078,1.44624347 100.859391,0.882017507 C101.432627,0.294271408 102.186327,0 102.941048,0 C103.695769,0 104.453261,0.294272599 105.02651,0.882017507 L105.02651,0.882017507 L105.714058,1.58912015 L106.401619,0.885739099 C107.548105,-0.289775724 109.422253,-0.289749524 110.568726,0.885739099 C111.715212,2.06122891 111.715212,3.94914116 110.568726,5.12463217 C109.00851,6.72433355 107.448999,8.3258213 105.888796,9.92548695 C105.842872,9.97305136 105.77899,10 105.712162,10 C105.645334,10 105.581452,9.97305136 105.535528,9.92548695 L105.535528,9.92548695 L100.859391,5.12090462 C100.556907,4.81017253 100.334229,4.44986168 100.19143,4.06618047 C100.074679,3.79527652 100.011457,3.50888162 100.001435,3.22115295 Z",
    id: "path-15"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Matches-guest-upgrade-with-statement-Copy",
    transform: "translate(-39.000000, -230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "matches-guest",
    transform: "translate(39.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#7BCB45",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#7BCB45",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#7BCB45",
    fillRule: "nonzero",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#7BCB45",
    fillRule: "nonzero",
    opacity: 0.5,
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#7BCB45",
    fillRule: "nonzero",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#7BCB45",
    fillRule: "nonzero",
    opacity: 0.648623512,
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#7BCB45",
    fillRule: "nonzero",
    opacity: 0.522623698,
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#7BCB45",
    fillRule: "nonzero",
    opacity: 0.3,
    xlinkHref: "#path-15"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchesGuest);
export default __webpack_public_path__ + "static/media/matches-guest.fec14bfe270427045be95e394da5ec14.svg";
export { ForwardRef as ReactComponent };